import ContractManagementTable from './ContractManagementTable';

export default ContractManagementTable;
